module.exports = __webpack_public_path__ + "img/lestnica_vneshnyaya_ulichnaya.7bd5dbc4.svg";